export default __webpack_public_path__ + "static/spark_app_account_list-0a5a1769c560a8616fb8c3fa75352c9a.png";